<!-- Modal Header -->
<div class="modal-header">
    <h3 class="align-center"><span [innerHTML]="data.title | translate"></span></h3>
</div>

<!-- Modal body -->
<div class="modal-body">
    <p [innerHTML]="data.text | translate"></p>
</div>
